<div
  class="chip"
  matTooltip="Sample Set Review"
  matTooltipPosition="above"
  matTooltipShowDelay="1000"
>
  SSR
</div>
